import axios from 'axios'
import API_URL from './settings'

export const axiosClient = axios.create({ baseURL: API_URL })

const ApiService = {
  getProChart(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_pro_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  saveChart(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('save_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  showChart(data) {
    //
    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('show_chart?_wpnonce=' + nonce, data).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'
    })
  },
  getVarga(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_varga_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getTransit(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_transit_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getPrashna(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_prashna_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  makeFreeChart(data) {
    return axiosClient.post('make_free_chart', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  // makeFreeChart(data) {
  //   return axiosClient.post('make_report_order', data).catch((error) => {
  //     throw new Error(`ApiService: ${error}`)
  //   })
  // },


  makeReportOrder(data) {
    return axiosClient.post('make_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  ///////////////////

  getPreOrderPsychologicalChart(data) {

    return axiosClient.get('get_psychological_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      // window.location.href = '/404'

    })
  },


  makePsychologicalReportOrder(data) {
    return axiosClient.post('make_psychological_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  ////////////////////


  getPreOrderGc10Chart(data) {

    return axiosClient.get('get_gc10_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'

    })
  },

  getPreOrderTlntChart(data) {

    return axiosClient.get('get_tlnt_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'

    })
  },




  getPreOrderKarmicChart(data) {

    return axiosClient.get('get_karmic_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      // window.location.href = '/404'

    })
  },



  getPreOrderChopraChart(data) {

    return axiosClient.get('get_chopra_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      // window.location.href = '/404'

    })
  },


  makeChopraReportOrder(data) {
    return axiosClient.post('make_chopra_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  ///////////////////


  makeKarmicReportOrder(data) {
    return axiosClient.post('make_karmic_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  makeGc10ReportOrder(data) {
    return axiosClient.post('make_gc10_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  makeTalentReportOrder(data) {
    return axiosClient.post('make_tlnt_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },




  /////////////////
  createReportOrder(data) {
    return axiosClient.post('create_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  getProChartPDF(data) {

    // let nonce = document.getElementsByName('nonce')[0].value;
    return `${API_URL}get_pdf?hash_id=${data['hash_id']}`;
    // return axiosClient.post('get_pdf?_wpnonce=' + nonce, data).catch((error) => {
    //   throw new Error(`ApiService: ${error}`)
    // })
  },
  savePrashna(data) {
    //
    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('save_prashna?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  showPrashna(data) {
    //
    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('show_prashna?_wpnonce=' + nonce, data).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'
    })
  },

  getFreeChartPart(data) {
    return axiosClient.post('get_free_chart_parts', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getFreePrashna(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_free_prashna?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  deleteChart(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('delete_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  listChart(params) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_chart_list?_wpnonce=' + nonce, params).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  listNote(params) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_note_list?_wpnonce=' + nonce, params).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getChartNotes(params) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_chart_notes?_wpnonce=' + nonce, params).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getNote(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_note?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  saveNote(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('save_note?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  updateNote(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('update_note?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  deleteNote(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('delete_note?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  chartNoteList(params) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_chart_note_list?_wpnonce=' + nonce, params).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  updateSettings(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('update_settings?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getSettings() {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_settings?_wpnonce=' + nonce).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getTehranNow() {

    return axiosClient.get('get_tehran_now').catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getFreeChart(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_free_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getMuhurtaChart(data) {

    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_muhurta_chart?_wpnonce=' + nonce, data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getNearestTimezone(data) {

    // let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.post('get_nearest_timezone', data).catch((error) => {
      throw new Error(`ApiService: ${error}`

      )
    })
  },
  getSharedChart(data) {

    return axiosClient.get('get_shared_chart', { params: { i: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      // window.location.href = '/404'

    })
  },
  getReportChart(data) {
    return axiosClient.get('get_report_parts', { params: { id: data } }).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  getReportChart_tal(data) {
    return axiosClient.get('get_report_parts_tal', { params: { id: data } }).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  getHoraStats(type) {

    return axiosClient.get('get_hora_stats?stat_type=' + type).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },
  getUserSubs() {
    let nonce = document.getElementsByName('nonce')[0].value;
    return axiosClient.get('get_user_subs?_wpnonce=' + nonce).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  getReportChart_love(data) {
    return axiosClient.get('get_report_parts_love', { params: { id: data } }).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  getPreOrderLoveChart(data) {

    return axiosClient.get('get_love_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'

    })
  },
  makeLoveReportOrder(data) {
    return axiosClient.post('make_love_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  //start of career codes


  getPreOrdercareerChart(data) {

    return axiosClient.get('get_career_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'

    })
  },


  MakeReportOrder(data , type) {
    const payload = {
      ...data,
      reportType: type,
    };

    return axiosClient.post('make_general_report_order', payload).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  getReportChart_career(data) {
    return axiosClient.get('get_report_parts_career', { params: { id: data } }).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },



  //start of wealth codes

  getPreOrderwealthChart(data) {

    return axiosClient.get('get_wealth_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'

    })
  },


  makewealthReportOrder(data) {
    return axiosClient.post('make_wealth_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  getReportChart_wealth(data) {
    return axiosClient.get('get_report_parts_wealth', { params: { id: data } }).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


  //start of health codes

  getPreOrderhealthChart(data) {

    return axiosClient.get('get_health_pre_order_chart', { params: { id: data } }).catch((error) => {
      // throw new Error(`ApiService: ${error}`)
      window.location.href = '/404'

    })
  },

  makehealthReportOrder(data) {
    return axiosClient.post('make_health_report_order', data).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },

  getReportChart_health(data) {
    return axiosClient.get('get_report_parts_health', { params: { id: data } }).catch((error) => {
      throw new Error(`ApiService: ${error}`)
    })
  },


}

export default ApiService
